module.exports = __webpack_public_path__ + "img/l16.a3c42f19.png";